import { getCookie } from "cookies-next";

import { brand } from "shared-lib/helpers/envFunctions";

export function getStatsigUserID(): string {
  return getCookie("userID") ?? "";
}

export function getStatsigUser() {
  const userID = getStatsigUserID();
  return {
    userID,
    customIDs: {
      brandID: brand.id,
    },
    custom: {
      user: userID,
      brand: brand.id,
    },
  };
}
